import Vue from 'vue'

//汇总数据
export function summaryData() {
    return Vue.axios({
        url: '/api/dataSummary/summaryData',
        method: 'get',
    })
}

// 总盘 - 回款金额统计
export function sumPaymentMoney(data) {
    return Vue.axios({
        url: '/api/dataSummary/sumPaymentMoney',
        method: 'get',
        params: {...data}
    })
}

//汇总销售
export function getSaleList(data) {
    return Vue.axios({
        url: '/api/dataSummary/salesList',
        method: 'get',
        params: {...data}
    })
}

//汇总执行
export function getExcuList(data) {
    return Vue.axios({
        url: '/api/dataSummary/executorList',
        method: 'get',
        params: {...data}
    })
}

//销售-客户列表
export function getCustomerList(data) {
    return Vue.axios({
        url: '/api/dataSummary/saleCustmer',
        method: 'get',
        params: {...data}
    })
}

//执行-已执行订单
export function getExOrderList(data) {
    return Vue.axios({
        url: '/api/dataSummary/executorOrder',
        method: 'get',
        params: {...data}
    })
}

//执行-已执行订单
export function getExUnsettedList(data) {
    return Vue.axios({
        url: '/api/dataSummary/unpaidOrder',
        method: 'get',
        params: {...data}
    })
}

// 2.0 汇总
export function getTotalData(data) {
    return Vue.axios({
        url: '/api/dataSummary/sumData',
        method: 'get',
        params: {...data}
    })
}

//2.0 客户列表
// export function getCustomerData(data){
//     return  Vue.axios({
//         url:'/api/dataSummary/summaryCustmer',
//         method: 'get',
//         params: {...data}
//     })
// }

// 获取客户消费详情 summaryCustomerConsume
export function getCustomerData(data) {
    return Vue.axios({
        url: '/api/dataSummary/summaryCustomerConsume',
        method: 'get',
        params: {...data,}
    })
}

//2.0 销售列表
export function getSaleData(data) {
    return Vue.axios({
        url: '/api/dataSummary/summarySale',
        method: 'get',
        params: {...data}
    })
}

//2.0 红人列表
export function getFboyData(data) {
    return Vue.axios({
        url: '/api/dataSummary/summaryArtisan',
        method: 'get',
        params: {...data}
    })
}

//2.0 红人列表
export function getExcuData(data) {
    return Vue.axios({
        url: '/api/dataSummary/summaryExecutor',
        method: 'get',
        params: {...data}
    })
}

//2.0 销售执行汇总
export function getSaleExcuData(data) {
    return Vue.axios({
        url: '/api/dataSummary/sumDataSummary',
        method: 'get',
        params: {...data}
    })
}

//2.0 销售-客户列表
export function getSaleCusData(data) {
    return Vue.axios({
        url: '/api/dataSummary/saleCustmerAll',
        method: 'get',
        params: {...data}
    })
}

//2.0 销售-执行-未执行订单
export function getNonOrderData(data) {
    return Vue.axios({
        url: '/api/dataSummary/executorOrderAll',
        method: 'get',
        params: {...data}
    })
}

//2.0 未结款订单
export function getNonPayData(data) {
    return Vue.axios({
        url: '/api/dataSummary/unpaidOrderAll',
        method: 'get',
        params: {...data}
    })
}


//2.0 客户列表
export function getPlatformData(data) {
    return Vue.axios({
        url: '/api/dataSummary/sumDataPlatform',
        method: 'get',
        params: {...data}
    })
}

//2.0 报表：订单明细
export function getOrderList(data) {
    return Vue.axios({
        url: '/api/dataSummary/order_list',
        method: 'get',
        params: {...data}
    })
}

// 销售新客订单详情
export function getOrdersNewCustomer(params) {
    return Vue.axios({
        url: '/api/dashboard/ordersNewCustomer',
        method: 'get',
        params
    })
}

// 招商维度
export function getSummaryInvestmentList(data) {
    return Vue.axios({
        url: '/api/dataSummary/summaryInvestmentList',
        method: 'get',
        params: data
    })
}

// 招商维度
export function getLiveGuaranteeRebateClaimStat(data) {
    return Vue.axios({
        url: '/api/dashboard/liveGuaranteeRebateClaimStat',
        method: 'get',
        params: data
    })
}


export function getSummaryNewBrandList(data) {
    return Vue.axios({
        url: '/api/dataSummary/summaryNewBrandList',
        method: 'get',
        params: data
    })
}

// 招商维度 - 星象仪产品库统计
export function getPdProductStat(data) {
    return Vue.axios({
        url: '/api/dashboard/pdProductStat',
        method: 'get',
        params: data
    })
}
